import { styled } from '@mui/material';

export const ProductsSliderContainer = styled('div')(({ theme }) => ({
  marginTop: '52px',

  [theme.breakpoints.up('sm')]: {
    marginTop: '60px',

    '&:first-of-type': {
      marginTop: 0,
    },
  },
}));
